export default "__VITE_ASSET__ce849517__"